module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-view', {
    attrs: {
      "endpoint": _vm.endpoint + 'image-categories',
      "name": "Category",
      "parentRoute": "categories",
      "permissions": "image-categories",
      "values": _vm.values
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64697f54","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CategoryEdit.vue
// module id = 405
// module chunks = 1